// extracted by mini-css-extract-plugin
module.exports = {"Photo":"PhotoThumbnail_Photo__1N_t5"};